import * as React from "react";

import "./Icon.css";

const SvgCreateIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 60 60"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <g transform="translate(6,6)">
      <path d="M47.23 20H28.8a.78.78 0 0 1-.8-.8V.77a.77.77 0 0 0-.74-.77h-6.52a.77.77 0 0 0-.74.77V19.2a.78.78 0 0 1-.77.77H.77a.77.77 0 0 0-.77.77v6.52a.77.77 0 0 0 .77.74H19.2a.78.78 0 0 1 .77.77v18.46a.77.77 0 0 0 .77.77h6.52a.77.77 0 0 0 .77-.77V28.8a.78.78 0 0 1 .77-.8h18.43a.77.77 0 0 0 .77-.77v-6.49a.77.77 0 0 0-.77-.74" />{" "}
    </g>
  </svg>
);
export default SvgCreateIcon;
